export enum MessagingExecutionType {
  IMMEDIATE = 'IMMEDIATE',
  DEBOUNCE = 'DEBOUNCE',
}
